export default "__VITE_ASSET__DFqB4$GS__"